<script>
/* eslint-disable vue/no-v-text-v-html-on-component */

import { mapGetters } from 'vuex';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { INLINES, MARKS } from '@contentful/rich-text-types';
import nodeTypes from '@/schemas/nodeTypes';
import ImageLoader from '@/components/shared/ImageLoader.vue';
import CodeBlock from './CodeBlock.vue';
import Checklist from './Checklist.vue';
import Note from './Note.vue';
import DataTable from './Table.vue';

export default {
  name: 'RichTextBlock',

  components: {
    CodeBlock,
    Checklist,
    Note,
    DataTable,
    ImageLoader,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      nodeTypes,

      options: {
        renderNode: {
          [INLINES.ENTRY_HYPERLINK]: (node) => `<a href="${this.getLink(node.data.target)}">
            ${node.content[0].value}
          </a>`,
        },
        renderMark: {
          [MARKS.CODE]: (node) =>
            /\n/.test(node) ? `<pre><code>${node}</code></pre>` : `<code>${node}</code>`,
        },
      },
    };
  },

  computed: {
    ...mapGetters('menu', ['getPageLink']),
  },

  methods: {
    text(node) {
      return documentToHtmlString(node, this.options);
    },

    componentName(id) {
      if (id.toLowerCase() === 'table') {
        return 'DataTable';
      }

      return id;
    },

    getLink(link) {
      return link ? this.getPageLink(link) : '';
    },
  },
};
</script>

<template>
  <div class="rich-text-block">
    <template v-for="node in data.content">
      <ImageLoader
        v-if="node.nodeType === 'embedded-asset-block'"
        :key="node.data.target.sys.id"
        class="image"
        :imgSrc="node.data.target.fields.file"
      />

      <component
        :is="componentName(node.data.target.sys.contentType.sys.id)"
        v-else-if="node.nodeType === 'embedded-entry-block'"
        :key="node.data.target.sys.id"
        :content="node.data.target.fields"
      />

      <component
        :is="nodeTypes[node.nodeType]"
        v-else
        :key="node.nodeType"
        class="text"
        v-html="text(node)"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.image {
  display: block;
  padding: $space-16 0;

  @include desktop-small {
    padding: $space-24 0;
  }
}

.text {
  max-width: $text-block-width;

  :deep(code) {
    @include caption-regular;
    @include inline-code;
  }

  :deep(pre) {
    @include multiline-code;
  }
}

blockquote {
  font-style: italic;
  margin: 0;

  &::before {
    content: '“';
  }

  &::after {
    content: '”';
  }

  :deep(p) {
    display: inline;
  }
}

@media print {
  .image {
    break-inside: avoid;
  }
}
</style>
